import React, { useMemo, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

import LocalStorageService from '../../services/localStorage';

import SearchForm from './SearchForm';
import SearchResult from './SearchResult';

const localStorageService = LocalStorageService.getService();

const searchKeys = [
  'lob',
  'procedure_code',
  'service_date',
  'keyword',
  'policy_type',
  'policy_shortname',
  'status',
  'access_token',
];

const getParamsCaseInsensitive = (params, keys) => {
  const result = {};
  for (const [key, value] of params.entries()) {
    const matchedKey = keys.find((k) => k.toLowerCase() === key.toLowerCase());
    if (matchedKey) {
      if (matchedKey === 'status') {
        result[matchedKey] = value.split(',');
      } else {
        result[matchedKey] = value;
      }
    }
  }
  return result;
};

const PolicySearch = () => {
  const { orgId } = useParams();
  const [searchParams] = useSearchParams();
  const instructionsRef = useRef();

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [showLOB, setShowLOB] = useState(true);

  const urlParams = useMemo(
    () => getParamsCaseInsensitive(searchParams, searchKeys),
    [searchParams]
  );
  const brandingInfo = localStorageService.getBrandingInfo();

  React.useEffect(() => {
    if (brandingInfo) {
      // instructionsRef.current.innerHTML = JSON.parse(brandingInfo).instructions;
    }
  }, [instructionsRef, brandingInfo]);

  return (
    <Box component="section" className="headerBox">
      <Grid container className="container">
        <Grid item size={12}>
          {/*<div ref={instructionsRef}></div>*/}

          <SearchForm
            onShowLOB={setShowLOB}
            showLOB={showLOB}
            onFormSubmit={setFormSubmitted}
            orgId={orgId}
            urlParams={urlParams}
            onDataChange={setSearchResult}
          />

          {formSubmitted && (
            <>
              <hr style={{ borderTop: '3px solid #ccc', margin: '20px 0' }} />
              <SearchResult
                lob={urlParams.lob}
                service_date={urlParams.service_date}
                showLOB={showLOB}
                searchResult={searchResult}
                orgId={orgId}
              />
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PolicySearch;
